module.exports = __webpack_public_path__ + "img/9791187206200.1538ad1f.jpg";